import { format, isValid } from 'date-fns'
import type { IntlService } from 'ember-intl'

/**
 * Converts a unix timestamp (eg 1318781876, as number or string) to a formatted month / day object, that can be useful
 * for calendar icon component.
 */
export function unixTimeToCalendarIconArgs(unixTimestamp: string | number, intl: IntlService) {
  let date

  if (typeof unixTimestamp === 'number') {
    date = new Date(unixTimestamp * 1000)
  }

  if (typeof unixTimestamp === 'string') {
    const parsedInt = Number.parseInt(unixTimestamp, 10)
    date = Number.isNaN(parsedInt) ? null : new Date(parsedInt * 1000)
  }

  if (!date || !isValid(date)) return {}

  const monthFormat = intl.t('dateFormats.dateFns.MMM')
  const dayFormat = intl.t('dateFormats.dateFns.dd')
  const exportFormat = intl.t('dateFormats.dateFns.MMM-dd')

  return {
    value: { month: format(date, monthFormat), day: format(date, dayFormat), exportValue: format(date, exportFormat) },
  }
}
